import { render } from "./document-updated-block.vue?vue&type=template&id=aeb6d718&scoped=true&ts=true&lang=pug"
import script from "./document-updated-block.vue?vue&type=script&lang=ts"
export * from "./document-updated-block.vue?vue&type=script&lang=ts"

import "./document-updated-block.vue?vue&type=style&index=0&id=aeb6d718&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb6d718"]])

export default __exports__